import { useState, useCallback } from "react"
import qs from "qs"

export function useQueryString(defaults = {}) {
  const newQueryString = qs.parse(location.search, {
    ignoreQueryPrefix: true,
    decoder: function (str, defaultDecoder, charset, type) {
      if (
        type === "value" &&
        /^(?:-(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*))|(?:0|(?:[1-9](?:\d{0,2}(?:,\d{3})+|\d*))))(?:.\d+|)$/.test(
          str
        )
      ) {
        return parseFloat(str)
      }

      const keywords = {
        true: true,
        false: false,
        null: null,
        undefined: undefined,
      }
      if (type === "value" && str in keywords) {
        return keywords[str]
      }

      return defaultDecoder(str, defaultDecoder, charset)
    },
  })

  const [parsedParams, setParams] = useState(() => ({
    ...defaults,
    ...newQueryString,
  }))

  const setQueryString = useCallback(
    (params) => {
      const newQueryString = qs.stringify(params, { encode: false })
      const location = [window.location.pathname, newQueryString].filter((i) => i).join("?")

      setParams(params)
      window.history.replaceState(params, new Date().getTime(), location)
    },
    [setParams]
  )

  return [parsedParams, setQueryString]
}
